import { shallowEqual, useAppDispatch, useAppSelector } from 'store'
import { useEffect } from 'react'
import {
  reset,
  fetchGetSupplyOrderDetail,
  fetchGetSupplyOrderDetailItem,
  fetchGetAllLocation,
  fetchGetSupplyOrderRemarks,
  fetchGetSupplyOrderType,
  fetchGetPurchaseOrderReferences,
  fetchPutSupplyOrderDetail,
} from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { useHistory, useParams } from 'react-router-dom'
import { Button } from '@astro-ui/components'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'
import { toastSuccess } from 'utils/toast'
import BasicDetail from './BasicDetail'
import Layout from './Layout'
import ProductDetail from './ProductDetail'
import RightPanel from './RightPanel'

const OutboundSOAddEdit = () => {
  const history = useHistory()

  const { id } = useParams<{ id: string }>()
  const isEdit = Boolean(id)

  const dispatch = useAppDispatch()

  const { isLoading, data, form } = useAppSelector((state) => state.outboundSOAddEdit, shallowEqual)

  const isFormValid = useAppSelector((state) => {
    const { soType, origin, destination, email, remarks } = state.outboundSOAddEdit.form
    const isReturnType = soType.toLowerCase() === 'return'

    const isEmailValid = email.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    const isDestinationValid = isReturnType ? !!form.poReff : !!destination

    return !!soType && !!origin && isDestinationValid && !!remarks && isEmailValid
  }, shallowEqual)

  const getSODetail = async () => {
    const res = await dispatch(fetchGetSupplyOrderDetail(Number(id))).unwrap()
    const { supplyOrderType } = res.data

    if (supplyOrderType.toLowerCase() === 'return') {
      dispatch(
        fetchGetPurchaseOrderReferences({
          poNumber: res.data.supplyOrderReff || undefined,
        }),
      )
    }
  }

  const handleSave = () => {
    const isReturnType = data?.supplyOrderType.toLowerCase() === 'return'

    const supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest'] = {
      createdBy: data?.supplyOrderCreatedBy || '',
      locationDestinationId: isReturnType
        ? form.poReff?.vendorId || 0
        : form.destination?.location_id || 0,
      locationOriginId: form.origin?.location_id || 0,
      remarks: form?.remarks?.code || '',
      poRef: form?.poReff || {},
      requestBy: form?.email || '',
      shippingInstructions: form?.shippingInstructions || '',
      soDate: form.soDate ? form.soDate.getTime() : 0,
      soReff: form.soReff || '',
      soType: form.soType || '',
      status: data?.supplyOrderStatus || '',
    }

    dispatch(
      fetchPutSupplyOrderDetail({
        supplyOrderId: Number(id),
        payload: {
          supplyOrderRequest,
        },
        onSuccess: () => {
          toastSuccess('Data berhasil diupdate')
          history.push(`/dashboard/outbound-so/detail/${id}`)
        },
      }),
    )

    if (isReturnType && form.poReff) {
      dispatch(
        fetchGetPurchaseOrderReferences({
          poNumber: form.poReff.poNumber,
        }),
      )
    }
  }

  useEffect(() => {
    dispatch(fetchGetSupplyOrderType())
    dispatch(fetchGetAllLocation())
    dispatch(fetchGetSupplyOrderRemarks())

    if (isEdit) {
      getSODetail()

      dispatch(
        fetchGetSupplyOrderDetailItem({
          supplyOrderId: Number(id),
          params: {
            pageIndex: 0,
          },
        }),
      )
    } else {
      const createSOState = localStorage.getItem('createSOState')
      if (!createSOState) {
        dispatch(reset())
      }
    }

    return () => {
      if (isEdit) {
        dispatch(reset())
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit])

  return (
    <Layout
      isLoading={isLoading}
      RightPanel={<RightPanel />}
      RightHeader={
        isEdit ? (
          <Button width={164} disabled={!isFormValid} onClick={handleSave}>
            Simpan
          </Button>
        ) : null
      }
    >
      <BasicDetail />
      <ProductDetail />
    </Layout>
  )
}

export default OutboundSOAddEdit
